import { useCallback } from "react";
import { useGatheringContext } from "src/contexts/GatheringContext";
import { CustomThemeModalProps } from "src/screens/(internal)/CustomThemeModal/types";
import usePresentGatheringThumbnailEdit from "../../../GatheringHomeHeader/components/EditThumbnailOverlay/hooks/usePresentGatheringThumbnailEdit";
import GatheringThemePreviewHeaderItem from "./components/GatheringThemePreviewHeaderItem";

const useRenderGatheringThemePreviewHeaderItem = () => {
	const { store } = useGatheringContext();
	const presentGatheringThumbnailEdit = usePresentGatheringThumbnailEdit({ skipQuery: true });

	const renderPreviewHeaderItem: CustomThemeModalProps["renderPreviewHeaderItem"] = useCallback(
		({ thumbnail, palette, reaction }) => {
			return (
				<GatheringThemePreviewHeaderItem
					store={store}
					thumbnailUrl={thumbnail?.readUrl}
					onThumbnailEdit={presentGatheringThumbnailEdit}
					palette={palette}
					reaction={reaction}
				/>
			);
		},
		[presentGatheringThumbnailEdit, store],
	);

	return { renderPreviewHeaderItem };
};

export default useRenderGatheringThemePreviewHeaderItem;
